module.exports = __webpack_public_path__ + "static/img/icon-more.ffa2400.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/icon-more.png
// module id = CugS
// module chunks = 15